import { useState } from "react";

import "flatpickr/dist/themes/airbnb.css";
import Flatpickr from "react-flatpickr";
import { useIntl } from "react-intl";
import { getDateAndTime } from "src/feature/bite/helpers/date";

interface FilterDrawerProps {
  filter: any
  setFilter: (filter: any) => void,
  search: string,
  setSearch: (search: string) => void
}

export default function FilterDrawer({
  filter,
  setFilter,
  search,
  setSearch,
}: FilterDrawerProps) {
  const intl = useIntl();

  const [value, setValue] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const submitFilter = () => {
    let date: any = [];

    const startDateNew = new Date(startDate).toISOString();
    const endDateNew = new Date(endDate).toISOString();

    if (startDate && endDate) {
      date = [
        {
          key: 'lstTrxDt',
          operator: 11,
          logicalOp: 1,
          value: [getDateAndTime(startDateNew), getDateAndTime(endDateNew)],
          childFilters: []
        }
      ];
    }

    setFilter([
      {
        key: '_id',
        operator: 14,
        logicalOp: 1,
        value: [value],
        childFilters: date
      }
    ]);
  }

  return (
    <>
      <div
        id='kt_filter'
        className='bg-body'
        data-kt-drawer='true'
        data-kt-drawer-name='filter'
        data-kt-drawer-activate='true'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'350px', 'md': '525px'}"
        data-kt-drawer-direction='end'
        data-kt-drawer-toggle='#kt_filter_toggle'
        data-kt-drawer-close='#kt_filter_close'
      >
        <div className='card rounded-0 w-100'>
          <div className='card-header pe-5'>
            <div className='card-title'>
              <div className='d-flex justify-content-center flex-column me-3'>
                <span className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 lh-1'>
                  {intl.formatMessage({ id: 'GLOBAL.FILTER.SELECTED' })}
                </span>
              </div>
            </div>

            <div className='card-toolbar'>
              <div
                className='btn btn-sm btn-icon btn-active-light-primary'
                id='kt_drawer_example_basic_close'
              >
                <span className='svg-icon svg-icon-2'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <rect
                      opacity='0.5'
                      x='6'
                      y='17.3137'
                      width='16'
                      height='2'
                      rx='1'
                      transform='rotate(-45 6 17.3137)'
                      fill='black'
                    ></rect>
                    <rect
                      x='7.41422'
                      y='6'
                      width='16'
                      height='2'
                      rx='1'
                      transform='rotate(45 7.41422 6)'
                      fill='black'
                    ></rect>
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div className='card-body hover-scroll-overlay-y'>
            <form id='filterForm'>
              <div className='px-7 py-5'>
                <div className='mb-5'>
                  <label className='form-label fw-bold'>{intl.formatMessage({ id: 'GLOBAL.FILTER.SEARCH' })}:</label>

                  <div className='row'>
                    <div className='col-md-12 mb-4'>
                      <input
                        className='form-control mr-sm-2'
                        type='search'
                        name='productSelectedSearch'
                        placeholder={intl.formatMessage({ id: 'GLOBAL.FILTER.SEARCH' })}
                        aria-label='Search'
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                      />
                    </div>
                  </div>
                </div>


                <div className='mb-5'>
                  <label className='form-label fw-bold'>{intl.formatMessage({ id: 'GLOBAL.FILTER.LAST_TRX_DATE' })}:</label>

                  <div className='row'>
                    <div className='col-md-6 mb-4'>
                      <Flatpickr
                        placeholder={intl.formatMessage({ id: 'GLOBAL.FILTER.START_DATE' })}
                        value={null}
                        onChange={(date) => {
                          setStartDate(date);
                        }}
                        name='endDate'
                        className='form-control mb-2'
                        options={{ dateFormat: 'm/d/Y' }}
                      />
                    </div>
                    <div className='col-md-6 mb-4'>
                      <Flatpickr
                        placeholder={intl.formatMessage({ id: 'GLOBAL.FILTER.END_DATE' })}
                        value={null}
                        onChange={(date) => {
                          setEndDate(date);
                        }}
                        name='endDate'
                        className='form-control mb-2'
                        options={{ dateFormat: 'm/d/Y' }}
                      />
                    </div>
                  </div>
                </div>


                {/* <div className='mb-5 flex'>
                  {allFilter().map((item, index) => (
                    <span className="badge badge-primary" style={{ marginRight: 5 }} key={index}>
                      {filterTypes.find((type) => type.key === item.key)?.label}

                      <span
                        style={{ marginLeft: 5 }}
                        className="cursor-pointer"
                        onClick={() => {
                          const newFilters = [...filters];
                          newFilters.splice(index, 1);
                          setFilters(newFilters);
                        }}
                      >
                        <i className="bi bi-x-circle-fill"></i>
                      </span>
                    </span>
                  ))}
                  <span
                    onClick={() => setShowFilter(!showFilter)}
                    className="badge badge-success cursor-pointer" style={{ marginLeft: 5 }}>
                    {showFilter ? 'Close New Filter' : 'Add Filter'}
                  </span>
                </div>

                {showFilter && (
                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Filter Types:</label>

                    <div className='row'>
                      <div className='col-md-10 mb-4'>
                        <select
                          className='form-control form-select form-select-solid'
                          data-control='select2'
                          data-placeholder='Select an option'
                          data-allow-clear='true'
                          defaultValue="nm"
                          onChange={(e) => {
                            setFilterType({
                              ...filterType,
                              key: e.target.value
                            })
                          }}
                        >
                          {filterTypes.map((item, index) => (
                            <option value={item.key} key={index}>{item.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2 mb-4">
                        <span
                          className='btn btn-success cursor-pointer'
                          onClick={() => addFilter()}
                        >
                          Add
                        </span>
                      </div>
                    </div>
                  </div>
                )} */}

                {/* <div className='mb-10'>
                  <label className='form-label fw-bold'>Status:</label>

                  <div className='row'>
                    <div className='col-md-12 mb-4'>
                      <select
                        className='form-control form-select form-select-solid'
                        data-control='select2'
                        data-placeholder='Select an option'
                        data-allow-clear='true'
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value='0'>All</option>
                        <option value='1'>Active</option>
                        <option value='2'>Passive</option>
                      </select>
                    </div>
                  </div>
                </div> */}
              </div>
            </form>
          </div>

          <div className='card-footer'>
            <div className='row'>
              <div className='col-md-6'>
                <button
                  type='reset'
                  className='btn w-100 btn-sm btn-light-danger'
                  id='kt_drawer_example_basic_close'
                >
                  {intl.formatMessage({ id: 'GLOBAL.FILTER.CLEAR' })}
                </button>
              </div>
              <div className='col-md-6'>
                <button
                  className='btn w-100 btn-sm btn-primary'
                  id='kt_filter_toggle'
                  onClick={() => {
                    submitFilter();
                    setSearch(value);
                  }}
                >
                  {intl.formatMessage({ id: 'GLOBAL.FILTER.SEARCH' })}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
